export const BRAND_NAME = "Voxa Book Airtisan";
export const BRAND_PRODUCT_NAME = "Airtisan";
export const BRAND_LOGO_PATH = "/static/img/voxa/Voxa-logo-no-text.png";
